exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-agent{position:absolute;top:5px;right:20px}.btm-delete-img-agent{position:absolute;top:5px;right:70px}.btm-remove-img-agent{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}.select2,.select2-dropdown{font-size:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Master/Agent/AgentUpdate.vue
// module id = 1049
// module chunks = 0